var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.usageRestricted
    ? _c("i18n", {
        attrs: {
          path: "account.accountUsage.limitReachedMessage",
          tag: "span",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "page",
              fn: function () {
                return [
                  _c("span", { staticClass: "bold" }, [
                    _vm._v(_vm._s(_vm.currentPageLabel)),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "clickLink",
              fn: function () {
                return [
                  _c("router-link", {
                    staticClass: "text-white clickable bold",
                    attrs: { to: { name: "account-plan" }, custom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var navigate = ref.navigate
                            return [
                              _c(
                                "span",
                                {
                                  attrs: { role: "link" },
                                  on: {
                                    click: navigate,
                                    keypress: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return navigate.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n        " +
                                      _vm._s(
                                        _vm.$t("global.actions.clickHere")
                                      ) +
                                      "\n      "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1877449360
                    ),
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          328347990
        ),
      })
    : _c("i18n", {
        attrs: { path: "account.accountUsage.remainingMessage", tag: "span" },
        scopedSlots: _vm._u([
          {
            key: "count",
            fn: function () {
              return [_vm._v("\n    " + _vm._s(_vm.remainingUsages) + "\n  ")]
            },
            proxy: true,
          },
          {
            key: "page",
            fn: function () {
              return [
                _c("span", { staticClass: "bold" }, [
                  _vm._v(_vm._s(_vm.currentPageLabel)),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "clickLink",
            fn: function () {
              return [
                _c("router-link", {
                  staticClass: "text-white clickable bold",
                  attrs: { to: { name: "account-plan" }, custom: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var navigate = ref.navigate
                        return [
                          _c(
                            "span",
                            {
                              attrs: { role: "link" },
                              on: {
                                click: navigate,
                                keypress: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return navigate.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.$t("global.actions.clickHere")) +
                                  "\n      "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }